import classnames from 'classnames';
import type { FunctionComponent } from 'react';

import { Chip } from '@/domains/core/tamagoshi/Chip/Chip';
import { useFacet } from '@/domains/productDiscovery/Listings/facets/hooks/useFacet';
import type { FacetValue } from '@/domains/productDiscovery/Listings/facets/hooks/useFacet/useFacet.interfaces';
import type { RefinedFacet } from '@/domains/productDiscovery/Listings/facets/hooks/useRefinedFacets';
import { useFilterConfig } from '@/domains/productDiscovery/Listings/hooks/useFilterConfig';

import { generateLabelByFacetValue } from './activeFilter.util';

import styles from './ActiveFilter.module.scss';

interface ActiveFilterProps {
  facetValue: RefinedFacet;
  className?: string;
}

export const ActiveFilter: FunctionComponent<ActiveFilterProps> = ({
  className,
  facetValue,
}) => {
  const rootClassnames = classnames(styles.root, className);
  const filterConfig = useFilterConfig(facetValue.facetName);
  const { removeFacetValue } = useFacet(facetValue.facetName);

  const removeFilterValue = () =>
    removeFacetValue(facetValue.value as FacetValue);

  return (
    <Chip
      className={rootClassnames}
      closable
      theme="outline"
      onClick={removeFilterValue}
    >
      <div className={styles.text}>
        {generateLabelByFacetValue(facetValue, filterConfig)}
      </div>
    </Chip>
  );
};

ActiveFilter.displayName = 'ActiveFilter';
